import styled from 'styled-components';
import { SmallBlock } from '../../components/MainComponents/MainComponents';
import { mainTheme } from '../../mainStyles';

export const StampViewWrapper = styled(SmallBlock)`
  display: inline-block;
  margin-bottom: ${mainTheme.offset.medium}px;
`;
